import axios from "axios";
import { getBaseUrl } from "..";
import { endpoint } from "../api";
import { normalizeEmail } from "../../services/email";

export interface IPayloadSignup {
  name: string | undefined;
  email: string | undefined;
  password: string | undefined;
  companyName: string | undefined;
  privacy: boolean | undefined;
}

export const signup = (data: IPayloadSignup): Promise<any> => {
  const normalizedData = {
    ...data,
    email: data.email ? normalizeEmail(data.email) : data.email,
  };

  return new Promise((resolve, reject) => {
    axios
      .post(`${getBaseUrl()}${endpoint.auth.signup()}`, normalizedData)
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};
